export default __webpack_public_path__ + "static/media/document-voilet.4a7d8b1c.svg";